import toast from 'react-hot-toast';
import useApi from '../useApi';

interface ConsentRecordedReq {
  phone: string;
  consentMessageReceivedStatus: string;
  associatedClinic: string;
  status: string;
}

interface ConsentRecordedRes {
  status: 'success' | 'fail';
  msg?: string;
}

const useSendConsentRecorded = () => {
  const url = `/rtm/patient-enrollment/send-consent-recorded`;
  const method = 'POST';
  const { loading: sendingConsentRecorded, makeApiCall } = useApi({ url, method });

  const sendConsentRecorded = async (formData: ConsentRecordedReq) => {
    const { response, error } = await makeApiCall<ConsentRecordedReq, ConsentRecordedRes>(formData);
    
    if (response?.status === 'success') {
      toast.success('Consent recorded successfully');
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to record consent. Please try again.');
      return { status: 'fail' };
    }
  };

  return {
    sendingConsentRecorded,
    sendConsentRecorded,
  };
};

export default useSendConsentRecorded;
